// Equalize card heights per container; no-ops when target blocks are absent, and resize is rAF-throttled so we recalc once per frame instead of reflowing synchronously on every resize event.
function equalizeCardHeights(containerSelector, cardSelector) {
  const containers = document.querySelectorAll(containerSelector);
  if (!containers.length) return;

  containers.forEach((container) => {
    const cards = container.querySelectorAll(cardSelector);
    if (!cards.length) return;

    // Reset all, then measure all, then write all — keeps reads and writes grouped.
    cards.forEach((card) => {
      card.style.minHeight = "auto";
    });

    let maxHeight = 0;
    cards.forEach((card) => {
      const cardHeight = card.offsetHeight;
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });

    cards.forEach((card) => {
      card.style.minHeight = maxHeight + "px";
    });
  });
}

function runEqualizers() {
  equalizeCardHeights(".blog--multicolumn", ".blog-article__title");
  equalizeCardHeights(".ambassdor-multicolumn", ".custom-height__title");
  equalizeCardHeights(".collectionseo-article_product", ".card-information .description");
}

runEqualizers();

// Throttle resize via requestAnimationFrame (was firing runEqualizers synchronously on every resize event, causing repeated forced-reflow layout thrash).
let equalizeScheduled = false;
window.addEventListener("resize", function () {
  if (equalizeScheduled) return;
  equalizeScheduled = true;
  requestAnimationFrame(function () {
    equalizeScheduled = false;
    runEqualizers();
  });
});
